import { OTHER_ROUTES } from '@/router/config';

import { SERVICE_CODES } from '@/lib/consts';

import { DeclaredDocumentsFormDataProps } from '../../../../../../components/Documents/DeclaredDocumentsCreate';
import { ExternalLink } from '../../../../../../components/Forms/ExternalLink/ExternalLink';
import {
  AdditionalDocumentFormDataProps,
  previewAdditionalDocument,
} from '../../../../../../components/Forms/Steps/AdditionalDocument';
import {
  ConfirmationOfApplication,
  ConfirmationOfApplicationFormDataProps,
} from '../../../../../../components/Forms/Steps/ConfirmationOfApplication';
import {
  PersonalAndPassportFormDataProps,
  previewPersonalAndPassportData,
} from '../../../../../../components/Forms/Steps/PersonalAndPassportData';
import {
  PlaceOfResidenceFormDataProps,
  previewPlaceOfResidence,
} from '../../../../../../components/Forms/Steps/PlaceOfResidence';
import { previewSingleWeapon } from '../../../../../../components/Forms/Steps/WeaponsData';
import { StepsNavigationName } from '../../../../../../config/services';
import { formatDate } from '../../../../../../helpers/dates';
import { NullValueGuard } from '../../../../../../middlewares/NullValueGuard';
import { currentServiceCode } from '../TemporaryResidenceRelocation';

import { WeaponsDataFieldName, WeaponsDataFormDataProps } from './Step2';
import { previewStep5 } from './Step5';

interface Props {
  formData: PlaceOfResidenceFormDataProps &
    DeclaredDocumentsFormDataProps &
    AdditionalDocumentFormDataProps &
    PersonalAndPassportFormDataProps &
    WeaponsDataFormDataProps &
    ConfirmationOfApplicationFormDataProps & {
      issuedResidence?: string;
      expiredResidence?: string;
    };
  handleInputChange: (name: string, value: unknown) => void;
}

const Step7: React.FC<Props> = ({ formData, handleInputChange }) => {
  const accordionData = [
    {
      title: StepsNavigationName.weaponData,
      content:
        currentServiceCode === SERVICE_CODES.RESIDENCE_RELOCATION ? (
          <div className="custom-columns custom-columns_grey-bg">
            <div className="custom-columns__row_padding-tiny">
              Зміна місця проживання власника зброї відноситься до всієї його зброї, що знаходиться на зберіганні.
              Перелік своєї зброї Ви можете переглянути за посиланням{' '}
              <ExternalLink href={OTHER_ROUTES.erz.WEAPON_REGISTERED}>Моя зброя</ExternalLink>
            </div>
          </div>
        ) : (
          <div className="custom-columns_grey-bg">
            {(formData[WeaponsDataFieldName.weapons] as unknown as string[]).map((stringifiedWeapon) => {
              return (
                <>
                  {previewSingleWeapon({
                    selectedWeapon: {
                      weapon: stringifiedWeapon,
                    },
                  })}
                </>
              );
            })}
          </div>
        ),
    },
    previewPersonalAndPassportData({ formData }),
    previewPlaceOfResidence({ formData }),
    previewStep5({ formData }),
    previewAdditionalDocument({ formData }),
  ];

  if (currentServiceCode === SERVICE_CODES.TEMPORARY_RESIDENCE_RELOCATION) {
    accordionData.push({
      title: 'Термін дії дозволу',
      content: (
        <div className="custom-columns custom-columns_grey-bg custom-columns_default-gap">
          <div className="custom-columns__row custom-columns__row_padding-tiny">
            <div className="custom-columns__col">
              <div className="custom-columns__title">Дата початку дії дозволу</div>
              <div className="custom-columns__info">
                <NullValueGuard>{formatDate(formData.issuedResidence ?? null)}</NullValueGuard>
              </div>
            </div>
          </div>
          <div className="custom-columns__row custom-columns__row_padding-tiny">
            <div className="custom-columns__col">
              <div className="custom-columns__title">Термін дії дозволу на тимчасову зміну місця проживання</div>
              <div className="custom-columns__info">
                <NullValueGuard>{formatDate(formData.expiredResidence ?? null)}</NullValueGuard>
              </div>
            </div>
          </div>
        </div>
      ),
    });
  }

  return (
    <ConfirmationOfApplication
      formData={formData}
      handleInputChange={handleInputChange}
      accordionData={accordionData}
    />
  );
};

export default Step7;
